import React from "react";
import { Link } from "react-router-dom";

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// pairs: [{ term, to }]  where `to` is the full router path
export function linkifyText(text, pairs, keyPrefix = "l") {
  if (!text || !pairs.length) return text;
  const sorted = [...pairs].sort((a, b) => b.term.length - a.term.length);
  const lookup = {};
  sorted.forEach((p) => { lookup[p.term.toLowerCase()] = p.to; });
  const pattern = sorted.map((p) => escapeRegex(p.term)).join("|");
  const regex = new RegExp(`\\b(${pattern})\\b`, "gi");

  const parts = [];
  let last = 0;
  let m;
  let k = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const matched = m[0];
    const to = lookup[matched.toLowerCase()];
    parts.push(
      <Link
        key={`${keyPrefix}-${k++}`}
        to={to}
        data-testid="article-auto-link"
        className="text-credit font-medium underline decoration-credit/40 underline-offset-4 hover:decoration-credit hover:bg-credit/10 transition-colors"
      >
        {matched}
      </Link>
    );
    last = regex.lastIndex;
    if (m.index === regex.lastIndex) regex.lastIndex++;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

// Build {term, to} pairs from raw article title targets for a language.
export function buildPairs(targets, lang, currentSlug) {
  const pairs = [];
  (targets || [])
    .filter((tg) => tg.slug !== currentSlug && tg.slug_en !== currentSlug)
    .forEach((tg) => {
      const title = tg[`title_${lang}`] || tg.title_nl || tg.title_en || "";
      const syns = (lang === "en" ? tg.synonyms_en : tg.synonyms_nl) || [];
      const to = lang === "en"
        ? `/en/wiki/${tg.slug_en || tg.slug}`
        : `/wiki/${tg.slug}`;
      [title, ...syns].forEach((term) => {
        if (term && term.trim()) pairs.push({ term: term.trim(), to });
      });
    });
  return pairs;
}
